export default function() {
  const widgetName = 'cardWidgetSEOText';
  const widgetOpts = cardWidgetSEOTextOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      $(`#${widgetName} a.moreButton`).text(data.items[0].DetailLinkText);

      // add animate.css classes
      const target = document.getElementById(`${widgetName}`);
      let options = {
        root: null,
        rootMargin: "0px",
        threshold: [0.5],
      };
      let callback = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.5) {
            $(entry.target).addClass('animate__animated animate__fadeInUp');
          }
        });
      };
      let observer = new IntersectionObserver(callback, options);
      observer.observe(target);

    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: false,
      margin: 10,
      navText: ['Prev','Next'],
      nav: false
    },
    textOverImage: false
  });

}